import { render, staticRenderFns } from "./WhatsNewItem.vue?vue&type=template&id=8a6ef6ce&scoped=true"
import script from "./WhatsNewItem.vue?vue&type=script&lang=js"
export * from "./WhatsNewItem.vue?vue&type=script&lang=js"
import style0 from "./WhatsNewItem.vue?vue&type=style&index=0&id=8a6ef6ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6ef6ce",
  null
  
)

export default component.exports